let  accountsChildrent = [
  {
    path: 'orderRecord',
    meta: {
      title: '订单记录',
      breadcrumb: true
    },
    component: {
      name: 'orderRecord',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '订单记录',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/orderRecord'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/orderRecord/detail'], resolve)
      }
    ]
  },
  {
    path: 'serviceAwardCheck',
    meta: {
      title: '服务奖结算核对',
      breadcrumb: true
    },
    component: {
      name: 'serviceAwardCheck',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '服务奖结算核对',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/serviceAwardCheck'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/serviceAwardCheck/detail'], resolve)
      }
    ]
  },
  {
    path: 'userWithdrawAuth',
    meta: {
      title: '光明使者提现审核',
      breadcrumb: true
    },
    component: {
      name: 'userWithdrawAuth',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '光明使者提现审核',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/userWithdrawAuth'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/userWithdrawAuth/detail'], resolve)
      }
    ]
  },
  {
    path: 'hubQuitApply',
    meta: {
      title: '中心清户',
      breadcrumb: true
    },
    component: {
      name: 'hubQuitApply',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',meta: {
          title: '中心清户',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/hubQuitApply'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/hubQuitApply/detail'], resolve)
      }
    ]
  },
  {
    path: 'hubAccountRecord',
    meta: {
      title: '中心账户记录',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/accountsManagement/hubAccountRecord'], resolve)
  },
  {
    path: 'agentsAuth',
    meta: {
      title: '代理提现审核',
      breadcrumb: true
    },
    component: {
      name: 'agentsAuth',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '代理提现审核',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/agentsAuth'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/agentsAuth/detail'], resolve)
      }
    ]
  },
  {
    path: 'agentsCheck',
    meta: {
      title: '代理结算核对',
      breadcrumb: true
    },
    component: {
      name: 'agentsCheck',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '代理结算核对',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/agentsCheck'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: "详情",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/agentsCheck/detail'], resolve)
      }
    ]
  },
  {
    path: 'dietExpertSettle',
    meta: {
      title: '食疗专家结算',
      breadcrumb: true
    },
    component: {
      name: 'dietExpertSettle',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '食疗专家结算',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/dietExpertSettle'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: '详情',
          breadcrumb: true
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/dietExpertSettle/detail'],resolve)
      }
    ]
  },
  {
    path: 'dietExpertWithdraw',
    meta: {
      title: '食疗专家提现',
      breadcrumb: true
    },
    component: {
      name: 'dietExpertWithdraw',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        meta: {
          title: '食疗专家提现',
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/dietExpertWithdraw'], resolve)
      },
      {
        path: 'detail',
        meta: {
          title: '详情',
          breadcrumb: true
        },
        component: (resolve) => require(['@/views/plat/accountsManagement/dietExpertWithdraw/detail'],resolve)
      }
    ]
  },
]


export default {
  path: '/accountsManagement',
  redirect: '/accountsManagement/orderRecord',
  meta: {
      title: "账务管理",
      breadcrumb: true
  },
  component: {
      name: 'accountsManagement',
      template: '<router-view></router-view>'
  },
  children: accountsChildrent
}


// WEBPACK FOOTER //
// ./src/router/accountsManagement.js